import { Alert, Box } from "@mui/material";
import { getUserAgentRegex } from "browserslist-useragent-regexp";
import { t } from "i18next";

const BrowserCompatibilityWarning = () => {
  let isCompatible = false;

  try {
    const userAgentRegex = getUserAgentRegex({
      browsers: ["defaults"],
      allowHigherVersions: true
    });
    isCompatible = userAgentRegex.test(navigator.userAgent);
  } catch (error) {
    console.error("Error checking browser compatibility:", error);
    console.error("User agent:", navigator.userAgent);
  }

  return (
    <Box>
      <Box>
        {!isCompatible && (
          <Alert severity="warning">{t("browser compatibility warning")}</Alert>
        )}
      </Box>
    </Box>
  );
};

export default BrowserCompatibilityWarning;
